var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTipResultDotNull(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12.375,
    height: 12.381,
    viewBox: "0 0 12.375 12.381",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.188 12.38c3.398 0 6.187-2.794 6.187-6.192C12.375 2.795 9.58 0 6.187 0 2.79 0 0 2.795 0 6.188c0 3.398 2.795 6.193 6.188 6.193zM4.436 9.019c-.416 0-.663-.276-.663-.721V3.99c0-.416.247-.68.633-.68.287 0 .446.094.692.422l2.12 2.913h.053V4.03c0-.45.24-.72.663-.72.421 0 .668.27.668.72v4.336c0 .404-.24.65-.622.65-.28 0-.445-.093-.673-.398l-2.15-2.953h-.053v2.63c0 .452-.247.722-.668.722z",
    fill: "#999",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTipResultDotNull);
export default __webpack_public_path__ + "static/media/tip-result-dot-null.f2c12f3cca5b534a576e4633b30a80d3.svg";
export { ForwardRef as ReactComponent };